<template>
  <div>
        
  </div>
</template>
<script>
import { mapActions } from 'vuex';

const accountModule = 'accountModule'

export default {
  data() {
    return {

    }
  },

  methods: {
    ...mapActions(accountModule, [
      'requestCheckKakaoAccount',
      'requestKakaoLogin',
      'requestKakaoSignup'
    ]),

    async setRedirectData() {
      const code = this.$route.query.code;
      const naverCheck = await this.requestCheckKakaoAccount(code)

      if (naverCheck) {
        await this.requestKakaoLogin(code)
        this.$router.push({ name: 'home' })
      } else {
        await this.requestKakaoSignup(code)
        alert('환영합니다')
        this.$router.push({ name: 'home' })
      }
    }
  },

  mounted() {
    this.setRedirectData()
  }
}
</script>
<style lang="">
    
</style>